'use strict';

module.exports = ['$scope', '$rootScope', '$timeout', function ($scope, $rootScope, $timeout) {
    // ------------------
    // Scope Functions
    // ------------------
    $scope.loadMonth = function (year, month) {
        $scope.selectedYear = year;
        $scope.selectedMonth = month;

        return $scope.dataSvc[$scope.dataServiceMethod]($scope.$root.plant, year, month).success(function (data) {
            $scope.month = data;
            $scope.restoreSelectedDay();

            $timeout($scope.$broadcast("calendar-resize"));
        });
    };

    $scope.isCurrentMonth = function () {
        var today = moment();
        return !!(today.year() == $scope.selectedYear && today.month() + 1 == $scope.selectedMonth);
    };

    $scope.nextMonth = function () {
        $scope.selectedMonth >= 12 ? $scope.loadMonth($scope.selectedYear + 1, 1) : $scope.loadMonth($scope.selectedYear, $scope.selectedMonth + 1);
    };
    $scope.previousMonth = function () {
        $scope.selectedMonth <= 1 ? $scope.loadMonth($scope.selectedYear - 1, 12) : $scope.loadMonth($scope.selectedYear, $scope.selectedMonth - 1);
    };

    $scope.currentMonthClick = function () {
        var today = moment();
        return $scope.loadMonth(today.year(), today.month() + 1);
    };

    $scope.selectDay = function (selectedDay) {

        $scope.month.weeks.map(function (week) {
            week.weekdays.map(function (day) {
                day._selected = day == selectedDay;
            });
        });

        $scope.selectedDay = selectedDay;
    };

    $scope.restoreSelectedDay = function () {
        // Restores the selected day setting from the current value of .selectedDay
        var s = $scope.selectedDay;

        if (!$scope.selectedDay)
            return;

        $scope.month.weeks.map(function (week) {
            week.weekdays.map(function (day) {
                var isDay = s.day == day.day && s.month == day.month && s.year == day.year;
                day._selected = isDay;
                if (isDay) {
                    $scope.selectedDay = day;
                }
            });
        });
    };

    $scope.getDateForNewEntry = function () {
        var date = $scope.selectedDay ? moment($scope.selectedYear + '-' + $scope.selectedMonth + '-' + $scope.selectedDay.day, "YYYY-MM-DD") : moment();
        return date.format($rootScope.dateFormat.moment);
    };

    // ------------------
    // Initialization
    // ------------------
    $scope.month = undefined;
    $scope.dataServiceMethod = "getCalendarData";

    $scope.selectedYear = 0;
    $scope.selectedMonth = 0; // Keep track of the month being displayed
    $scope.selectedDay = null;

}];